export const UNLEASH_APP_NAME = 'sweepking-fe';
export const UNLEASH_CLIENT_REFRESH_INTERVAL_SECONDS = 30;
export const UNLEASH_BOOTSTRAP_REVALIDATE_SECONDS = 60 * 60;
